import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--light-orange)";

function IconValentinesDot({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path fill={fill} fill-rule="evenodd" clip-rule="evenodd" d="M6 3.12c-1.105-1.19-3.065-1.497-4.44-.605C-.122 3.605-.422 5.918.554 7.845c.482.951 1.564 1.546 2.587 2.108l.176.097c1.092.592 2.65 1.378 2.65 1.378L6 11.421l.034.007s1.557-.786 2.65-1.378l.175-.097c1.023-.562 2.105-1.157 2.587-2.108.976-1.927.676-4.24-1.006-5.33C9.065 1.623 7.105 1.93 6 3.12z"/>
        </svg>
    );
}

export default IconValentinesDot;
